import React, { PureComponent, Fragment } from 'react'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { fetchEmpresas, uploadPFX, downloadPFX } from '../actions/empresasActions'
import { Loader } from 'modules/shared'
import { DateTime } from 'luxon'
import Select from 'react-select'
import { Card, CardText, CardBody, CardTitle, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { formatCNPJ, getDecodedToken, showNotification } from 'helpers'
import EmpresasCertificadoForm from './EmpresasCertificadoForm'

class Empresas extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            filteredCompanies: [],
            shouldShow: false,
            config: {
                empresa: null,
                type: null,
                index: 0
            }
        }
    }

    componentWillMount() {
        this.props.fetchEmpresas()
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.empresasState.empresas.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }

    expand(event) {
        if (event.currentTarget.classList.contains('btn-outline-info')) {
            event.currentTarget.parentElement.lastChild.style.visibility = 'hidden'
            event.currentTarget.parentElement.lastChild.style.opacity = 0
            event.currentTarget.parentElement.lastChild.style.maxHeight = '0px'
            event.currentTarget.classList.toggle('btn-outline-info')
        } else {
            event.currentTarget.parentElement.lastChild.style.visibility = 'visible'
            event.currentTarget.parentElement.lastChild.style.opacity = 1
            event.currentTarget.parentElement.lastChild.style.maxHeight = '999px'
            event.currentTarget.classList.toggle('btn-outline-info')
            event.currentTarget.blur()
        }
    }

    toggleModal(object = null) {
        if (object) {
            this.setState({ 
                shouldShow: !this.state.shouldShow,
                config: object 
            })
        } else {
            this.setState({ 
                shouldShow: !this.state.shouldShow,
                config: {
                    empresa: null,
                    type: null,
                    index: 0
                }
            })
        }
    }

    submit(values) {
        if (values.pfx && values.cnpj && values.senha) 
            return this.props.uploadPFX(values, this.state.config)
            .then(() => {
                if (this.props.empresasState.statusUpload !== null && this.props.empresasState.statusUpload === true) {
                    this.toggleModal()
                    this.props.fetchEmpresas()
                }
            })
        else 
            showNotification('Por favor, preencha o formulário.', 'alert-warning', 3000)
    }

    render () {

        let { loading, empresas } = this.props.empresasState

        if (loading)
            return <Loader />

        empresas = empresas && empresas.length ? empresas : []
        const options = empresas.map(p => {
            return { value: p._id, label: p.nomeEmpresa }
        })
    
        empresas = this.state.filteredCompanies.length ? empresas.filter(p => this.state.filteredCompanies.includes(p._id)) : empresas

        const user = getDecodedToken()

        return (
            <div className="container">
                <div className="row">
                    <div className="col col-sm-4 mt-2">
                        <Select
                            options={options}
                            defaultValue={empresas.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => {
                                return { value: p._id, label: p.nomeEmpresa }
                            })}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterCompanies(value)} 
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.props.fetchEmpresas()} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt"></i>
                            Atualizar                        
                        </button>
                    </div>

                </div>

                <div className="row">
                    {empresas.map((p, index) => {
                        const status = p.certificados.length === 0 || (p.certificados.length && (p.certificados.map(c => c.validity.end).filter(c => DateTime.fromJSDate(new Date(c)) < DateTime.local()).length === p.certificados.length ) ) ? <Fragment><span className="badge badge-dark" style={{ minWidth: 50, borderRadius: 0 }}>STATUS</span><span className="badge badge-danger" style={{ borderRadius: 0 }}>ERRO</span></Fragment> : <Fragment><span className="badge badge-dark" style={{ minWidth: 50, borderRadius: 0 }}>STATUS</span><span className="badge badge-success" style={{ borderRadius: 0 }}>OK</span></Fragment>
                        return (
                            <div key={index} className="col col-sm-4 company-card">
                                <Card className="shadow-effect">
                                    <CardBody style={{ fontSize: '.76rem' }}>

                                        <button className="btn btn-sm btn-info float-right" onClick={event => this.expand(event)}>
                                            <i className="fas fa-external-link-alt"></i>
                                        </button>

                                        <CardTitle className="company-title">{status}</CardTitle>
                                        <CardText className="my-0"><strong className="pr-1">EMPRESA:</strong>{p.nomeEmpresa}</CardText>
                                        <CardText className="my-0"><strong className="pr-1">ESTADO:</strong>{p.estado}</CardText>
                                        <CardText className="my-0"><strong className="pr-1">TIPO:</strong>{p.tipoNF}</CardText>
                                        <CardText className="my-0"><strong className="pr-1">CNPJ ATIVO:</strong>{formatCNPJ(p['cnpjPrincipal'])}</CardText>
                                    
                                        <div className="expansible" style={{ fontSize: '.8rem' }}>
                                            <CardText className="mt-2"><strong className="pr-1">CERTIFICADO 1:</strong></CardText>
                                            {p['certificados'].length === 0 && <button className="btn btn-primary btn-sm" disabled={!([5,18].includes(user.setor))} onClick={() => this.toggleModal({ empresa: p['_id'], type: 'conf', index: 0 })}><i style={{ paddingRight: 5 }} className="fas fa-wrench"></i> Configurar</button>}
                                            {p['certificados'].length > 0 && <CardText className="my-0"><strong className="pr-1">CNPJ:</strong> {formatCNPJ(p['certificados'][0]['cnpj'])}</CardText>}
                                            {p['certificados'].length > 0 && <CardText className="my-0"><strong className="pr-1">VÁLIDO ATÉ:</strong> {DateTime.fromJSDate(new Date(p['certificados'][0]['validity']['end'])).toFormat('dd/MM/yyyy HH:mm:ss')}</CardText>}
                                            {p['certificados'].length > 0 && <CardText className="my-0"><strong className="pr-1">SENHA:</strong> {p['certificados'][0]['pwd']}</CardText>}
                                            {p['certificados'].length > 0 &&
                                                <div className="field is-grouped">
                                                    <button style={{ marginTop: 15 }} className="btn btn-primary btn-sm" onClick={event => this.props.downloadPFX(p['_id'], p['certificados'][0]['cnpj'], p['nomeEmpresa'].toLowerCase().replace(/\s/g, '') + '.pfx')}><i style={{ paddingRight: 5 }} className="fas fa-download"></i> Download PFX</button>
                                                    <button style={{ marginTop: 15, marginLeft: 10 }} className="btn btn-primary btn-sm" disabled={!([5,18].includes(user.setor))} onClick={event => this.toggleModal({ empresa: p['_id'], type: 'change', index: 0 })}><i style={{ paddingRight: 5 }} className="fas fa-sync-alt"></i> Trocar</button>
                                                </div>
                                            }

                                            {p['certificados'].length >= 1 && <CardText className="mt-2"><strong className="pr-1">CERTIFICADO 2:</strong></CardText>}
                                            {p['certificados'].length === 1 && <button className="btn btn-primary btn-sm" disabled={!([5,18].includes(user.setor))} onClick={() => this.toggleModal({ empresa: p['_id'], type: 'conf', index: 1 })}><i style={{ paddingRight: 5 }} className="fas fa-wrench"></i> Configurar</button>}
                                            {p['certificados'].length > 0 && p['certificados'][1] !== undefined && <CardText className="my-0"><strong className="pr-1">CNPJ:</strong> {formatCNPJ(p['certificados'][1]['cnpj'])}</CardText>}
                                            {p['certificados'].length > 0 && p['certificados'][1] !== undefined && <CardText className="my-0"><strong className="pr-1">VÁLIDO ATÉ:</strong> {DateTime.fromJSDate(new Date(p['certificados'][1]['validity']['end'])).toFormat('dd/MM/yyyy HH:mm:ss')}</CardText>}
                                            {p['certificados'].length > 0 && p['certificados'][1] !== undefined && <CardText className="my-0"><strong className="pr-1">SENHA:</strong> {p['certificados'][1]['pwd']}</CardText>}
                                            {p['certificados'].length > 0 && p['certificados'][1] !== undefined &&
                                                <div className="field is-grouped">
                                                    <button style={{ marginTop: 15 }} className="btn btn-primary btn-sm" onClick={event => this.props.downloadPFX(p['_id'], p['certificados'][1]['cnpj'], p['nomeEmpresa'].toLowerCase().replace(/\s/g, '') + '.pfx')}><i style={{ paddingRight: 5 }} className="fas fa-download"></i> Download PFX</button>
                                                    <button style={{ marginTop: 15, marginLeft: 10 }} className="btn btn-primary btn-sm" disabled={!([5,18].includes(user.setor))} onClick={event => this.toggleModal({ empresa: p['_id'], type: 'change', index: 1 })}><i style={{ paddingRight: 5 }} className="fas fa-sync-alt"></i> Trocar</button>
                                                </div>
                                            }

                                        </div>

                                    </CardBody>
                                </Card>
                            </div>
                        )
                    })}
                
                </div>

                <Modal isOpen={this.state.shouldShow} size="lg" toggle={() => this.toggleModal()}>
                    <ModalHeader toggle={() => this.toggleModal()}>Configurar certificado</ModalHeader>
                    <ModalBody style={{ fontSize: '.85rem' }}>
                        <EmpresasCertificadoForm onSubmit={values => this.submit(values)} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-secondary" onClick={() => this.toggleModal()}>Fechar</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = store => ({ empresasState: store.empresasState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchEmpresas, uploadPFX, downloadPFX }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Empresas)